export default {
    MARRIED: 'MARRIED',
    SINGLE: 'SINGLE',
    DIVORCED: 'DIVORCED',
    WIDOWED: 'WIDOWED',
  };
  